import { Button } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import {
  getIntegrationLogo,
  getIntegrationName,
} from 'src/core/modules/integrations/utils';

type Props = {
  externalUrl: string;
};

export const ViewTrip = ({ externalUrl }: Props) => {
  const { t } = useTranslation('global');
  return (
    <div className="flex flex-row items-center gap-16 rounded-8 border border-solid border-border-default px-16 py-12">
      <img
        src={getIntegrationLogo('travelperk')}
        alt={getIntegrationName(t, 'travelperk')}
        className="block h-32 w-32 rounded-8"
      />

      <div>{t('payables.panel.automaticallyCollectedReceipt')}</div>

      <Button
        className="ml-auto h-24 underline"
        fit="content"
        variant="tertiaryNeutral"
        text={t('integration.travelperk.viewTrip')}
        hasNoHorizontalPadding
        component="a"
        href={externalUrl}
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  );
};
